import { useNavigate, useSearch } from '@tanstack/react-router'
import { useCallback } from 'react'
import { z } from 'zod'

export const questsSearchSchema = z.object({
  quests: z
    .union([z.literal('active-quests'), z.literal('quests-history')])
    .optional(),
})

export type QuestSearchValue = z.infer<typeof questsSearchSchema>['quests']

export const useQuestsLaunch = () => {
  const navigate = useNavigate()
  const questSearchParamValue = useSearch({
    from: '__root__',
    select: (query) => query.quests,
  })

  const close = useCallback(() => {
    return navigate({
      to: '.',
      search: (prev) => ({
        ...prev,
        quests: undefined,
      }),
      resetScroll: false,
      replace: true,
    })
  }, [navigate])

  const open = useCallback(
    () =>
      navigate({
        to: '.',
        search: (prev) => ({
          ...prev,
          quests: 'active-quests',
        }),
        resetScroll: false,
        replace: true,
      }),

    [navigate],
  )

  const changeTab = useCallback(
    (questSearchValue: QuestSearchValue) =>
      navigate({
        to: '.',
        search: (prev) => ({
          ...prev,
          quests: questSearchValue,
        }),
        resetScroll: false,
        replace: true,
      }),

    [navigate],
  )

  return {
    open,
    close,
    changeTab,
    questSearchParamValue,
  }
}
